import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { getIntegrationsForMember } from '../helpers/integrationAdapters';
import IntegrationIcon from './IntegrationIcon';
import IntegrationsPopover from './IntegrationsPopover';

const IconRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IntegrationsCell = ({ admin, networkSlug, hasGoogleSync, hasOutlookSync, isCurrentUser }) => {
  if (!admin.onboardingCompleted) return null;

  const integrations = getIntegrationsForMember(admin, { hasGoogleSync, hasOutlookSync });

  const trigger = (
    <IconRow>
      {integrations.map((integration) => (
        <IntegrationIcon key={integration.type} type={integration.type} state={integration.iconState} />
      ))}
    </IconRow>
  );

  return (
    <IntegrationsPopover
      integrations={integrations}
      memberFirstName={admin.firstName || admin.name?.split(' ')[0] || ''}
      networkSlug={networkSlug}
      isCurrentUser={isCurrentUser}
      trigger={trigger}
    />
  );
};

IntegrationsCell.propTypes = {
  admin: PropTypes.shape({
    onboardingCompleted: PropTypes.bool,
    firstName: PropTypes.string,
    name: PropTypes.string,
    linkedinSyncStatus: PropTypes.string,
  }).isRequired,
  networkSlug: PropTypes.string.isRequired,
  hasGoogleSync: PropTypes.bool.isRequired,
  hasOutlookSync: PropTypes.bool.isRequired,
  isCurrentUser: PropTypes.bool.isRequired,
};

export default IntegrationsCell;
